define('shared/remote/payment/directDebit/convertOptionsToPayload',[
],
function(    
) {
    return function (directDebit) {
        if (!directDebit.account) {
            throw 'Account must be specified';
        }

        if (!directDebit.account.name) {
            throw 'Name must be specified';
        }

        if (!directDebit.account.number) {
            throw 'Number must be specified';
        }

        if (!directDebit.bank) {
            directDebit.bank = {};
        }

        return {
            'AccountName': directDebit.account.name,
            'AccountNumber': directDebit.account.number,
            'BankCode': directDebit.bank.code
        };
    };
});
